import _ from 'lodash'

import { DomainSupplyChain } from 'features/globalSetup/types/domainSupplyChain'
import { Schema } from './schema'

export const mapToFormField = (data: DomainSupplyChain[]): Schema['domainSupplyChainsSids'] =>
  _.chain(data).keyBy('id').mapValues('customDomainSid').value()
